import { hostName } from "./enviroment";

export const inlineAttachment = (window as any).inlineAttachment
export const getInlineAttachmentConfig = (window as any).getInlineAttachmentConfig

export const addSimpleMdebyClass = (className: string, onSave: Function | undefined = undefined, onChange: (renderedHTML: string, rawText: string)=> void | undefined = undefined) => {
  (window as any).addSimpleMdebyClass(className, onSave, onChange)
}

export const settupMde = (markEditor) => {
    inlineAttachment.editors.codemirror4.attach(markEditor.simplemde.codemirror, {
      uploadUrl: `${hostName}/pictures_simplemde`,
      uploadFileName: 'file',
      onFileUploadResponse: function (xhr) {
        var result = JSON.parse(xhr.responseText)
        if (!result['uploaded']) {
          alert('File invalid')
          return false
        }
  
        var url = result['url']
  
        if (result && url) {
          var newValue
          if (typeof this.settings.urlText === 'function') {
            newValue = this.settings.urlText.call(this, url, result)
          } else {
            newValue = this.settings.urlText.replace(this.filenameTag, url)
          }
          var text = this.editor.getValue().replace(this.lastValue, newValue)
          this.editor.setValue(text)
          this.settings.onFileUploaded.call(this, url)
        }
        return false
      }
    })
  }
  